export const DEFAULT_TRADE_DATA = {
    Username: "",
    give: "",
    receive: "",
    timeStamp: "",
    uid: ""
}